import React from 'react';
import cssClasses from './rules.css';

const Definition = (props) => {
    const { item } = props;

    if (item.Field === "Description") {
        return (
            (item.Operator === 'Contains')
            ? <div>Description contains <span className={cssClasses.ruleColour}>{item.Value.toLowerCase().replace(/''/g, "'")}</span></div>
            : <div>Description contains <span className={cssClasses.ruleColour}>{item.Operator.toLowerCase()}</span> of the key words <span className={cssClasses.ruleColour}>{item.Value.toLowerCase().replace(/''/g, "'")}</span></div>
        );
    }

    if (item.Field === "Reference") {
        return (
            (item.Operator === 'Contains')
            ? <div>Reference contains <span className={cssClasses.ruleColour}>{item.Value.replace(/''/g, "'")}</span></div>
            : <div>Reference contains <span className={cssClasses.ruleColour}>{item.Operator.toLowerCase()}</span> of the key words <span className={cssClasses.ruleColour}>{item.Value.toLowerCase().replace(/''/g, "'")}</span></div>
        );
    }

    if (item.Field === "Type") {
        return (
            (item.Operator === 'Contains')
            ? <div>Type contains <span className={cssClasses.ruleColour}>{item.Value.toLowerCase().replace(/''/g, "'")}</span></div>
            : <div>Type contains <span className={cssClasses.ruleColour}>{item.Operator.toLowerCase()}</span> of the key words <span className={cssClasses.ruleColour}>{item.Value.toLowerCase().replace(/''/g, "'")}</span></div>
        );
    }

    let operator = item.Operator.toLowerCase();
    if  (operator === "lessthan") {
        operator = "less than";
    } else if (operator === "greaterthan") {
        operator = "greater than";
    }

    return (
        <div>
            Amount is <span className={cssClasses.ruleColour}>{operator}</span> $<span className={cssClasses.ruleColour}>{item.Value}</span>
        </div>);
};

export default Definition;


// WEBPACK FOOTER //
// ./src/components/Rules/definition.js